import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useUser from "../../hook/useUser.js";
import { FaCaretLeft } from "react-icons/fa";
import { FaChevronLeft } from "react-icons/fa";
import Header from "../Header.js";
import api from "../../api/axios.js";

const QuizMain = () => {
    const navigate = useNavigate();
    const { user } = useUser();
    const [quizzes, setQuizzes] = useState([]);

    useEffect(() => {
        api.get(`/api/quizzes`)
        .then((res) =>{
            console.log(res.data);
            setQuizzes(res.data);
        })
        .catch((err) => {
        console.log("Error:", err); // ← 追加
        });
    }, []);

    return (
        <>
            <div className="dashboard-wrapper">
                <Header />
               {/* <div onClick={() => navigate(-1)} style={{ cursor: "pointer" }} className="nav_title">
                        <FaChevronLeft className="fa-chevron-left"/>
                        Your quizzes
                </div> */}
                {/* dashboardに戻る */}
                <div onClick={() => navigate('/dashboard')} style={{ cursor: "pointer" }} className="nav_title">
                    <FaChevronLeft className="fa-chevron-left"/>
                    Your Progress
                </div>
                <div className="quiz_main_section">
                {Array.isArray(quizzes) && quizzes.map((quiz) => {
                    return (
                        <div key={quiz._id} className="quiz_card">     
                    <h2 className="quiz_main_quiz_title">{quiz.title}</h2>
                    <button onClick={() => navigate(`/quiz/${quiz._id}/intro`)}>
                        Start your quiz
                    </button>
                    <button
                      onClick={() => {
                        if (!user || !user.employeeId) {
                          alert("User not found");
                          return;
                        }
                        navigate(`/quiz/${quiz._id}/${user.employeeId}/result`);
                      }}
                    >
                        View your result
                    </button>
                    <button onClick={() => navigate("/quiz/" + quiz._id + "/feedback")}>
                     View your feedback
                    </button>
                </div>
                
                    );
                })}
                </div>
            </div>
        </>
    );
}

export default QuizMain;